exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filtersContainer-1quha{margin-top:20px}.filtersContainer-1quha .filters-2UxNV{display:grid;grid-auto-flow:column;grid-column-gap:20px}", ""]);

// exports
exports.locals = {
	"filtersContainer": "filtersContainer-1quha",
	"filters": "filters-2UxNV"
};